<template>
    <div class="columns is-multiline values-border">
        <div class="column is-full">
            <a
            class="has-text-danger m-b-10"
            @click="isDeleteModalActive=true">
                <b-icon 
                icon="trash-alt" 
                size="is-small">
                </b-icon> 
                Delete
            </a>
            <a
            class="has-text-success m-b-10"
            @click="isAddValueModalActive=true">
                <b-icon 
                icon="plus" 
                size="is-small">
                </b-icon> 
                Agregar valor a atributo.
            </a>
            <b-field label="Titulo">
                <b-input
                    v-model="data.title"
                    max="60"
                    required
                    @input="updateAttr">                
                </b-input>
            </b-field>
        </div>
        <div class="column is-full ">
            <b-field label="Valores"></b-field>
        </div>
        <div v-for="(val, index) in data.values" :key="val.id" :index="index" class="column is-one-quarter">
            <b-field >
                <b-input
                    v-model="val.title"
                    max="60"
                    required
                    @input="updateVal(val.id, val.title)">                
                </b-input>
                <div class="control">
                    <a class="button is-danger "
                    @click="deleteVal(val.id)">
                        <b-icon icon="times" size="is-small"></b-icon>
                    </a>
                </div>
            </b-field>
        </div>

        <b-modal :active.sync="isDeleteModalActive" :width="640" scroll="keep">
            <div class="modal-card has-text-centered" style="width: auto">
                
                <section class="modal-card-body">
                    <p class="is-size-5">Keep in mind this action can't be undone.</p>
                    <p class="is-size-5">Deleting this attribute will also delete all the values related to it.</p>
                    </section>
               
                    <div class="columns is-centered">
                        <div class="column is-full has-text-centered">
                             <b-button type="is-outlined is-centered has-text-centered"
                                @click="isDeleteModalActive=false">
                                    Cancel
                                </b-button>
                                <b-button 
                                type="is-danger is-centered has-text-centered"
                                @click="deleteAttr">
                                    Delete
                                </b-button>
                        </div>
                    </div>
            </div>
        </b-modal>
        <b-modal :active.sync="isAddValueModalActive"  scroll="keep">
            <div class="modal-card has-text-centered" style="width: auto">
                
                <div class="modal-card-body">
                    <div class="columns">
                         <div class="column is-full">
                            <b-field label="Valores a agregar">
                            </b-field>
                            <b-field class="p-0 m-0">
                                <b-taginput
                                    v-model="newValues"
                                    class="p-0 m-0"
                                    ellipsis
                                    placeholder="Agregar valor">
                                </b-taginput>
                                
                            </b-field>
                        </div>
                    </div>
                </div>
                <div class="columns is-centered ">
                    <div class="column is-full has-text-centered">
                            <b-button 
                            class="m-r-5"
                            type="is-outlined"
                            @click="isAddValueModalActive=false">
                                Cancelar
                            </b-button>
                            <b-button 
                            type="is-primary"
                            @click="addValToAttribute">
                            <b-icon
                            icon="save"
                            size="is-small">
                            </b-icon>
                                Guardar valores
                            </b-button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {patchHandler, debounce, deleteHandler, postHandler} from "./../../../../services/http.js"
export default {
    data(){
        return{
            isDeleteModalActive:false,
            newValues:[],
            isAddValueModalActive:false
        }
    },
    props:{
        data:{
            type:Object,
            default: new Object({})
        },
        attributesDetail:{
            type:String,
            default:""
        },
        attrValDetail:{
            type:String,
            default:""
        },
        attrValCreate:{
            type:String,
            default:""
        }
    },
    methods:{
        updateAttr: debounce(async function(){
            let success = {
                resource:'toast'
            }
            let error = {
                resource:'toast'
            }
            let url = this.attributesDetail.replace("0000", this.data.id)
            let response = await patchHandler(url, {title:this.data.title}, {success, error})
            console.log(response)
        }, 500),
        updateVal: debounce(async function(val, title){ 
            let success = {
                resource:'toast'
            }
            let error = {
                resource:'toast'
            }
            let url = this.attrValDetail.replace("0000", val)
            let response = await patchHandler(url, {title}, {success, error})
        }, 500),
        async deleteAttr(){
            let success = {
                resource:'toast'
            }
            let error = {
                resource:'toast'
            }
            let url = this.attributesDetail.replace("0000", this.data.id)
            let resp = await deleteHandler(url, {success, error})
            this.isDeleteModalActive = false
            this.$emit('reloadAttrs')
            
        },
        async deleteVal(val){
            let success = {
                resource:'toast'
            }
            let error = {
                resource:'toast'
            }
            let url = this.attrValDetail.replace("0000", val)
            let response = await deleteHandler(url, {success, error})
            this.$emit('reloadAttrs')
        },
        async addValToAttribute(){
            let success = {
                resource:'toast'
            }
            let error = {
                resource:'toast'
            }
            let body = []
            this.newValues.forEach(element => {
                body.push({title:element, attribute:this.data.id})
            });
            let response = postHandler(this.attrValCreate, body, {success, error})
            this.data.values + body 
            this.newValues = []
            this.$emit('reloadAttrs')
            this.isAddValueModalActive=false
        }
    }
}
</script>

<style lang="scss" scoped>

.values-border{
    border-bottom:0.8px #ddd solid;
}

</style>
